import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const GeoreferencedSearchService = {
    list: async (data) => axios.post(API_URL + `/georeferencedSearch/list`, data).then(({data}) => data.data.data).catch((err) => { throw err }),
    listSentryView: async (data) => axios.post(API_URL + `/georeferencedSearch/sentryGeoreferencedSearch`, data).then(({data}) => data.data.data).catch((err) => { throw err }),
    limitSearch: async () => axios.get(API_URL + `/georeferencedSearch/getLimitSearchTime`).then(({data}) => data.data).catch((err) => { throw err }),
};

export default GeoreferencedSearchService;